import styled from 'styled-components';
import {DEVICE, Webcam} from '@chekin/guestapp-ui-kit';

export const StyledWebcam = styled(Webcam)`
  position: relative;
  width: 100dvw;
  height: 100dvh;
  border-radius: 0;

  & .webcam__scan-area {
    height: 248px;
    width: 248px;
    aspect-ratio: 1/1;

    @media (min-width: ${DEVICE.mobileXL}) {
      min-height: 248px;
      min-width: 248px;
      max-width: 370px;
      max-height: 370px;
      height: auto;
      width: auto;
    }
  }
`;
